import { ImportStep } from './types'

const ONE_FILE_PARSING_ESTIMATED_TIME_MS = 100
const ONE_LOG_PARSING_ESTIMATED_TIME_MS = 500

type Props = {
  step: ImportStep
  filesCount: number
  logsCount: number
  uploadedFilesCount: number
}

type Output =
  | {
      progress: number
      duration?: number
    }
  | {
      fromProgress: number
      toProgress: number
      duration?: number
    }

export const filesToProgress = (
  uploaded: number,
  total: number,
  maxProgress = 0.45,
) => {
  if (total <= 0) return 0
  return Math.min((uploaded / total) * maxProgress, maxProgress)
}

export const getProgressConfig = ({
  step,
  filesCount,
  logsCount,
  uploadedFilesCount,
}: Props): Output => {
  switch (step) {
    case 'sending:uploadFiles':
      return {
        // progress: filesToProgress(uploadedFilesCount, filesCount, 0.45),
        fromProgress: filesToProgress(uploadedFilesCount - 1, filesCount, 0.45),
        toProgress: filesToProgress(uploadedFilesCount, filesCount, 0.45),
        duration: 200,
      }
    case 'polling:uploadStatus':
      return {
        fromProgress: 0.45,
        toProgress: 0.9,
        duration: 1000 + filesCount * ONE_FILE_PARSING_ESTIMATED_TIME_MS,
      }
    case 'fetching:uploadDetails':
      return {
        fromProgress: 0.9,
        toProgress: 1,
        duration: 2000,
      }
    case 'sending:importData':
      return {
        fromProgress: 0,
        toProgress: 0.3,
        duration: 2000,
      }
    case 'polling:importStatus':
      return {
        fromProgress: 0.3,
        toProgress: 0.95,
        duration: 1000 + logsCount * ONE_LOG_PARSING_ESTIMATED_TIME_MS,
      }
    case 'fetching:importDetails':
      return {
        fromProgress: 0.95,
        toProgress: 1,
        duration: 2000,
      }
    default:
      return {
        progress: 0,
        duration: 2000,
      }
  }
}
